import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AdminService } from '../services/admin.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addeditadminlist',
    templateUrl: './addeditadminlist.component.html',
    styleUrls: ['./addeditadminlist.component.css']
})
export class AddEditAdminlist implements OnInit {
    element: any = {};
    createMode = true;
    grouplist: any = []
    myForm: any = FormControl;
    constructor(
        public dialogRef: MatDialogRef<AddEditAdminlist>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        private adminService: AdminService) {
        this.element = data;
        this.createMode = data.mode === 'create';

        this.myForm = this.fb.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required]],
            group: ['', [Validators.required]],
            phone: [''],
            telegram_chat_id: [''],
            password: ['', this.createMode ? [Validators.required, Validators.minLength(6)] : []],
            passwordrepeat: ['', this.createMode ? [Validators.required, Validators.minLength(6)] : []],
        });

    }
    ngOnInit() {
        this.getUserGroup();
    }
    getUserGroup() {
        const { notif } = defaults;
        this.adminService.getUserGroups().subscribe((success) => {
            this.grouplist = success;
        }, (error) => {
            this.notifSer.error(
                'User Group',
                error.error.message,
                notif
            )
        })

    }
    getErrorMessage(message: any): string {
        if (!message) {
            return 'Something went wrong';
        }
        if (typeof message === 'string') {
            return message;
        }
        return Object.values(message).join(', ');
    }

    async saveEditAdminlist() {
        this.userService.csrf().subscribe(data => {
            const { notif } = defaults
            this.myForm.value['_csrf'] = data['_csrf'];

            if (this.myForm.valid && this.element.mode == 'create') {
                this.adminService.createAdminUser(this.myForm.value).subscribe(result => {
                    if (result.status) {
                        this.notifSer.success('Success', result.message, notif)
                        // Emit the form data when closing the dialog

                        this.dialogRef.close({ success: true, data: result });

                    } else this.notifSer.error('Error', this.getErrorMessage(result.message), notif);
                }, err => this.notifSer.error('Error', this.getErrorMessage(err.error && err.error.message), notif))
            } else if (this.myForm.valid && this.element.mode === 'edit') {
                this.myForm.value['_id'] = this.element['_id'];
                this.adminService.editAdminUser(this.myForm.value).subscribe((result) => {
                    if (result.status) {
                        this.notifSer.success(
                            'Update User',
                            result.message,
                            notif
                        )
                        this.dialogRef.close({ success: true, data: result });
                    } else this.notifSer.error('Error', this.getErrorMessage(result.message), notif);
                }, (error) => {
                    this.notifSer.error(
                        'Error',
                        this.getErrorMessage(error.error && error.error.message),
                        notif
                    )
                })
            }
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/addeditadminlist/addeditadminlist.component.ts